import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  Container,
  IconButton,
  Grid,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaLinkedinIn } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { FaWhatsapp } from "react-icons/fa";
import { FaTelegram } from "react-icons/fa";
import { FaTiktok } from "react-icons/fa6";
import { CountryFlag } from "../../CommonPage/MarketFlow/CountryFlag";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const validationSchema = Yup.object({
  firstName: Yup.string().required("First Name is required"),
  lastName: Yup.string().required("Last Name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone is required"),
  phone1: Yup.string().required("Country is required"),
  experience: Yup.string().required("Experience level is required"),
  message: Yup.string().required("Cover letter is required"),
});

const CareersForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [show, setShow] = useState(false);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      phone1: "Lebanon",
      experience: "",
      message: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm, setStatus }) => {
      setSubmitted(true);
      try {
        // Prepare form data for Zoho CRM
        const formData = new URLSearchParams();
        formData.append('xnQsjsdp', '649a339b751896d53fb326269a898e8e9d54d8572214a1905ed329a150f0efef');
        formData.append('xmIwtLD', 'bc6ce98438cd990bad626cc5a5effe4ecd8767559a39a46842a0400210f93f69d9ce3645f91619c1d281369f611001e6');
        formData.append('actionType', 'TGVhZHM=');
        formData.append('returnURL', 'https://yourdomain.com/thank-you');
        formData.append('First Name', values.firstName);
        formData.append('Last Name', values.lastName);
        formData.append('Email', values.email);
        formData.append('Phone', values.phone);
        formData.append('Country', values.phone1);
        formData.append('LEADCF5', values.experience);
        formData.append('Lead Status', 'New Lead');
        formData.append('Lead Source', 'Web Research');

        // Submit to Zoho CRM
        const response = await fetch('https://crm.zoho.com/crm/WebToLeadForm', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData
        });

        if (response.ok) {
          setShow(true);
          setSubmitted(false);
          resetForm();
        } else {
          console.error('Failed to submit to Zoho CRM');
          setSubmitted(false);
          alert("Something went wrong. Please try again.");
          setShow(false);
        }
      } catch (error) {
        setSubmitted(false);
        console.error("Error submitting form:", error);
        alert("Something went wrong. Please try again.");
        setShow(false);
      }
    },
  });

  return (
    <Box px={{ xs: 2, sm: 3, md: 6, lg: 11 }} py={4}>
      <Box
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        gap={6}
      >
        {/* Left Side */}
        <Box
          flex={1}
          alignItems={{ xs: "center", md: "flex-start" }}
          textAlign={{ xs: "center", md: "left" }}
        >
          <Typography variant="h2" fontWeight="bold" gutterBottom>
            Join Our
            <br /> Team
          </Typography>
          <Typography
            color="text.secondary"
            mb={2}
            fontWeight="500"
            fontSize="22px"
          >
            Ready to start your career with BBCorp?
            <br /> Submit your application and we'll get
            <br /> back to you soon.
          </Typography>
          <Box
            display="flex"
            gap={1}
            sx={{
              justifyContent: { xs: "center", sm: "start" },
              marginLeft: { xs: "0px", sm: "-10px" },
            }}
          >
            <IconButton
              component="a"
              href="https://api.whatsapp.com/send?phone=96178709578"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#25D366",
                  transform: "scale(1.2)",
                },
              }}
              aria-label="whatsapp"
            >
              <FaWhatsapp />
            </IconButton>

            <IconButton
              component="a"
              href="https://www.instagram.com/bbcorpfx/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#E1306C",
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Instagram"
            >
              <FaInstagram />
            </IconButton>

            <IconButton
              component="a"
              href="https://www.facebook.com/people/BBCorp/100094393060215/?mibextid=wwXIfr&rdid=fkECT0btkzJdCpYx&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1BedSuHhZf%2F%3Fmibextid%3DwwXIfr"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#1877F2",
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Facebook"
            >
              <FiFacebook />
            </IconButton>
            <IconButton
              component="a"
              href="https://tiktok.com/@bbcorpfx"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#010101",
                  transform: "scale(1.2)",
                },
              }}
              aria-label="tiktok"
            >
              <FaTiktok />
            </IconButton>
            <IconButton
              component="a"
              href="https://x.com/BBcorpSAL"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#000",
                  transform: "scale(1.2)",
                },
              }}
              aria-label="Twitter"
            >
              <FaXTwitter />
            </IconButton>
            <IconButton
              component="a"
              href="https://t.me/bbcorpltd"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: "#667085",
                transition: "all 0.3s ease",
                "&:hover": {
                  color: "#0088CC",
                  transform: "scale(1.2)",
                },
              }}
              aria-label="telegram"
            >
              <FaTelegram />
            </IconButton>
          </Box>
        </Box>

        {/* Right Side (Form) */}
        <Box
          flex={2}
          component="form"
          onSubmit={formik.handleSubmit}
          display="flex"
          flexDirection="column"
          gap={2}
        >
          {/* Name Fields */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              fullWidth
              label="First name"
              name="firstName"
              value={formik.values.firstName}
              onChange={formik.handleChange}
              error={
                formik.touched.firstName && Boolean(formik.errors.firstName)
              }
              helperText={formik.touched.firstName && formik.errors.firstName}
              InputLabelProps={{
                sx: {
                  color: "#667085",
                  fontSize: "16px",
                  fontWeight: "500",
                  marginTop:"-3px",
                  "&.Mui-focused": {
                    color: "#667085",
                  },
                },
              }}
              InputProps={{
                sx: {
                  color: "blue",
                  "& .MuiInputBase-input": {
                    backgroundColor: "rgba(102, 112, 133, 0.1)",
                    padding: "12px 14px",
                    borderRadius: "8px",
                    fontWeight: 500,
                    fontSize: 16,
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0,
                },
              }}
            />
            <TextField
              fullWidth
              label="Last name"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              error={formik.touched.lastName && Boolean(formik.errors.lastName)}
              helperText={formik.touched.lastName && formik.errors.lastName}
              InputLabelProps={{
                sx: {
                  color: "#667085",
                  fontSize: "16px",
                  fontWeight: "500",  
                  marginTop:"-3px",
                  "&.Mui-focused": {
                    color: "#667085",
                  },
                },
              }}
              InputProps={{
                sx: {
                  color: "blue",
                  "& .MuiInputBase-input": {
                    backgroundColor: "rgba(102, 112, 133, 0.1)",
                    padding: "12px 14px",
                    borderRadius: "8px",
                    fontWeight: 500,
                    fontSize: 16,
                  },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  marginLeft: 0,
                },
              }}
            />
          </Box>

          {/* Email and Phone */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box sx={{ flex: 1 }}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                InputLabelProps={{
                  sx: {
                    color: "#667085",
                    fontSize: "16px",
                    fontWeight: "500",
                    marginTop:"-3px",
                    "&.Mui-focused": {
                      color: "#667085",
                    },
                  },
                }}
                InputProps={{
                  sx: {
                    color: "blue",
                    "& .MuiInputBase-input": {
                      backgroundColor: "rgba(102, 112, 133, 0.1)",
                      padding: "12px 14px",
                      borderRadius: "8px",
                      fontWeight: 500,
                      fontSize: 16,
                    },
                  },
                }}
                FormHelperTextProps={{
                  sx: {
                    marginLeft: 0,
                  },
                }}
              />
            </Box>

            <Box sx={{ flex: 1 }}>
              <PhoneInput
                country={"lb"}
                value={formik.values.phone}
                onChange={(phone) => formik.setFieldValue("phone", phone)}
                inputStyle={{
                  width: "100%",
                  height: "48px",
                  fontSize: "0.9rem",
                  paddingLeft: "48px",
                  paddingLeft: "60px",
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                }}
                buttonStyle={{
                  height: "48px",
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                }}
                containerStyle={{
                  width: "100%",
                  backgroundColor: "transparent",
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                }}
                specialLabel=""
              />
              {formik.touched.phone && formik.errors.phone && (
                <Typography variant="caption" color="error">
                  {formik.errors.phone}
                </Typography>
              )}
            </Box>
          </Box>

          {/* Country and Experience */}
          <Box
            display="flex"
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <Box sx={{ flex: 1 }}>
              <Select
                fullWidth
                name="phone1"
                value={formik.values.phone1}
                onChange={formik.handleChange}
                IconComponent={() => null}
                sx={{
                  height: 48,
                  fontWeight: 500,
                  fontSize: "18px",
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  pl: 0,
                }}
                renderValue={(selected) => {
                  const country = CountryFlag.find((c) => c.name === selected);
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "stretch",
                        height: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          backgroundColor: "rgba(102, 112, 133, 0.1)",
                          padding: "13px",
                          marginLeft: "-13px",
                          borderTopLeftRadius: "8px",
                          borderBottomLeftRadius: "8px",
                          px: 1.5,
                          height: "100%",
                        }}
                      >
                        <img
                          src={country?.flag}
                          alt={country?.name}
                          style={{
                            width: 24,
                            height: 24,
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                        <KeyboardArrowDownIcon sx={{ fontSize: 20, ml: 1 }} />
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          px: 2,
                        }}
                      >
                        <Typography sx={{ fontWeight: 400, fontSize: "15px",fontFamily: "SF Pro Display",}}>
                          {country?.name}
                        </Typography>
                      </Box>
                    </Box>
                  );
                }}
              >
                {CountryFlag.map((c) => (
                  <MenuItem
                    key={c.name}
                    value={c.name}
                    sx={{
                      fontSize: "15px",
                      fontWeight: 500,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={c.flag}
                      alt={c.name}
                      style={{
                        width: 24,
                        height: 24,
                        objectFit: "cover",
                        marginRight: 8,
                      }}
                    />
                    {c.name}
                  </MenuItem>
                ))}
              </Select>

              {formik.touched.phone1 && formik.errors.phone1 && (
                <Typography variant="caption" color="error">
                  {formik.errors.phone1}
                </Typography>
              )}
            </Box>

            <Box sx={{ flex: 1 }}>
              <Select
                fullWidth
                name="experience"
                value={formik.values.experience}
                onChange={formik.handleChange}
                displayEmpty
                IconComponent={() => null}
                sx={{
                  height: 48,
                  fontWeight: 500,
                  fontSize: "18px",
                  backgroundColor: "rgba(102, 112, 133, 0.1)",
                  display: "flex",
                  alignItems: "center",
                  pl: 0,
                  borderRadius: "8px",
                  border: "1px solid transparent",
                  "&:hover": {
                    backgroundColor: "rgba(102, 112, 133, 0.15)",
                    border: "1px solid rgba(25, 171, 226, 0.3)",
                  },
                  "&.Mui-focused": {
                    border: "1px solid #19ABE2",
                    backgroundColor: "rgba(102, 112, 133, 0.1)",
                  },
                  "& .MuiSelect-select": {
                    padding: "12px 14px",
                    borderRadius: "8px",
                    fontWeight: 500,
                    fontSize: 16,
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      mt: 1,
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid rgba(102, 112, 133, 0.2)",
                      "& .MuiMenuItem-root": {
                        fontSize: "15px",
                        fontWeight: 500,
                        padding: "12px 16px",
                        "&:hover": {
                          backgroundColor: "rgba(25, 171, 226, 0.1)",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "rgba(25, 171, 226, 0.15)",
                          color: "#19ABE2",
                          fontWeight: 600,
                          "&:hover": {
                            backgroundColor: "rgba(25, 171, 226, 0.2)",
                          },
                        },
                      },
                    },
                  },
                }}
                renderValue={(selected) => {
                  if (!selected) {
                    return (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          px: 2,
                          py: 1,
                          color: "#667085",
                          width: "100%",
                        }}
                      >
                        <Typography 
                          sx={{ 
                            fontWeight: 400, 
                            fontSize: "15px", 
                            fontFamily: "SF Pro Display",
                            color: "#667085",
                          }}
                        >
                          Experience Level
                        </Typography>
                        <KeyboardArrowDownIcon 
                          sx={{ 
                            fontSize: 20, 
                            color: "#667085",
                            transition: "transform 0.2s ease",
                          }} 
                        />
                      </Box>
                    );
                  }
                  return (
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        px: 2,
                        py: 1,
                        width: "100%",
                      }}
                    >
                      <Typography 
                        sx={{ 
                          fontWeight: 500, 
                          fontSize: "15px", 
                          fontFamily: "SF Pro Display",
                          color: "#000",
                        }}
                      >
                        {selected}
                      </Typography>
                      <KeyboardArrowDownIcon 
                        sx={{ 
                          fontSize: 20, 
                          color: "#667085",
                          transition: "transform 0.2s ease",
                        }} 
                      />
                    </Box>
                  );
                }}
              >
                <MenuItem 
                  value="Entry Level (0-2 years)"
                  sx={{
                    borderBottom: "1px solid rgba(102, 112, 133, 0.1)",
                  }}
                >
                  Entry Level (0-2 years)
                </MenuItem>
                <MenuItem 
                  value="Mid Level (3-5 years)"
                  sx={{
                    borderBottom: "1px solid rgba(102, 112, 133, 0.1)",
                  }}
                >
                  Mid Level (3-5 years)
                </MenuItem>
                <MenuItem 
                  value="Senior Level (5+ years)"
                  sx={{
                    borderBottom: "1px solid rgba(102, 112, 133, 0.1)",
                  }}
                >
                  Senior Level (5+ years)
                </MenuItem>
                <MenuItem value="Executive Level">
                  Executive Level
                </MenuItem>
              </Select>
              {formik.touched.experience && formik.errors.experience && (
                <Typography variant="caption" color="error">
                  {formik.errors.experience}
                </Typography>
              )}
            </Box>
          </Box>

          {/* Cover Letter */}
          <TextField
            fullWidth
            multiline
            minRows={4}
            name="message"
            label="Cover Letter..."
            value={formik.values.message}
            onChange={formik.handleChange}
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
            InputLabelProps={{
              sx: {
                color: "#667085",
                fontSize: "16px",
                fontWeight: 500,
                "&.Mui-focused": {
                  color: "#667085",
                },
              },
            }}
            InputProps={{
              sx: {
                color: "blue",
                backgroundColor: "rgba(102, 112, 133, 0.1)",
                borderRadius: "8px",
                padding: "12px",
                fontWeight: 500,
                fontSize: 16,
              },
            }}
            FormHelperTextProps={{
              sx: {
                marginLeft: 0,
              },
            }}
          />

          {/* Submit */}
          {show && (
            <Grid item xs={12}>
              <Typography variant="body2" color="rgba(89, 175, 153, 1)" style={{ fontSize: '16px' }} fontWeight="500">
                Thank you! We'll review your application and get back to you soon.
              </Typography>
            </Grid>
          )}
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Button
              type="submit"
              sx={{
                background: "#19ABE2",
                color: "#fff",
                width: "160px",
                borderRadius: "8px",
                textTransform: "none",
              }}
            >
              {submitted ? "Submitting..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CareersForm; 